import { Component, OnInit } from '@angular/core';
import { NavController, NavParams, ModalController } from 'ionic-angular';
import { FormBuilder, FormGroup } from '@angular/forms';

import * as firebase from 'firebase'; // TODO: update to only use 'firebase/auth'

import { PrivacyPage } from '../../pages/privacy/privacy';
import { TermsPage } from '../../pages/terms/terms';
import { MapModalPage } from '../../pages/map-modal/map-modal';
import { HomePage } from '../../pages/home/home';

import { AuthProvider } from '../../providers/auth/auth';
import { WindowProvider } from '../../providers/window/window';

import { IRecruiterUser } from '../../interfaces/users';
import { IAddress } from '../../interfaces/address';

@Component({
  selector: 'page-register-recruiter',
  templateUrl: 'register-recruiter.html'
})
export class RegisterRecruiterPage implements OnInit {
  fbUser: any;
  providerId: string;
  windowRef: any;
  registerForm: FormGroup;
  verificationForm: FormGroup;
  isConfirmed = false;

  // TODO: pull cellphone number through from initial phone auth on login... if that is what the user did

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private formBuilder: FormBuilder,
    private authProvider: AuthProvider,
    private win: WindowProvider,
    public modalCtrl: ModalController
  ) {
    this.registerForm = this.formBuilder.group({
      firstName: [''],
      lastName: [''],
      email: [''],
      cellphone: [''],
      companyName: [''],
      registrationNumber: [''],
      companyAddressLine1: [''],
      companyAddressLine2: [''],
      companyAddressCity: [''],
      companyAddressProvince: [''],
      companyAddressPostal: [''],
      businessType: ['']
    });
    this.verificationForm = this.formBuilder.group({
      verificationCode: ['']
    });
  }

  ngOnInit() {
    const self = this;
    self.authProvider.getFbUser().then(fbUser => {
      self.fbUser = fbUser;
      if (self.fbUser !== null) {
        console.log(self.fbUser.providerData[0].providerId);
        self.providerId = self.fbUser.providerData[0].providerId;
        self.registerForm.controls.cellphone.setValue(
          self.fbUser.phoneNumber.replace('+27', '0')
        );
      } else {
        console.log(fbUser);
        self.windowRef = self.win.windowRef;
        self.windowRef.recaptchaVerifier = new firebase.auth.RecaptchaVerifier(
          'recaptchaContainerRegister'
        );
        self.windowRef.recaptchaVerifier.render();
      }
    });
  }

  ionViewDidLoad() {
    // TODO: add analytics
  }

  sendLoginCode() {
    const self = this;
    const appVerfier = self.windowRef.recaptchaVerifier;
    const num = `+27${self.registerForm.controls.cellphone.value}`; // TODO: create a service/method that converts numbers enetered into correct format

    console.log(self.registerForm.value);
    // TODO: check if the register form is valid
    firebase
      .auth()
      .signInWithPhoneNumber(num, appVerfier)
      .then(res => {
        self.windowRef.confirmationResult = res;
        self.isConfirmed = true;
      })
      .catch(err => {
        console.log(err);
      });
  }

  verifyLoginCode() {
    const self = this;
    self.windowRef.confirmationResult
      .confirm(self.verificationForm.controls.verificationCode.value)
      .then(res => {
        console.log(res);
        self.providerId = 'phone';
        self.createProfile(res.user.uid);
      })
      .catch(err => {
        console.log(err);
      });
  }

  createProfile(uid: string) {
    const self = this;
    if (self.registerForm.valid) {
      let address: IAddress = {
        line1: self.registerForm.value.companyAddressLine1,
        line2: self.registerForm.value.companyAddressLine2,
        city: self.registerForm.value.companyAddressCity,
        province: self.registerForm.value.companyAddressProvince,
        postalCode: self.registerForm.value.companyAddressPostal
      };

      let user: IRecruiterUser = {
        uid: uid,
        firstName: self.registerForm.value.firstName,
        lastName: self.registerForm.value.lastName,
        email: self.registerForm.value.email,
        cellphone: self.registerForm.value.cellphone,
        companyName: self.registerForm.value.companyName,
        registrationNumber: self.registerForm.value.registrationNumber,
        businessType: self.registerForm.value.businessType,
        regType: 'recruiter',
        provider: self.providerId,
        address: address
      };
      self.authProvider
        .createRecruiterUser(user)
        .then(() => {
          var OneSignal = window['OneSignal'] || [];
          OneSignal.push(function() {
            OneSignal.sendTag('regType', 'recruiter');
          });

          location.reload();
          // self.navCtrl.setRoot(HomePage);
        })
        .catch(err => {
          console.log(err);
        });
    }
  }

  openPage(page: string) {
    const self = this;
    switch (page) {
      case 'privacy': {
        self.navCtrl.push(PrivacyPage);
        break;
      }
      case 'terms': {
        self.navCtrl.push(TermsPage, { regType: 'recruiter' });
        break;
      }
    }
  }

  openMapModal() {
    const self = this;
    let mapModal = self.modalCtrl.create(MapModalPage);
    mapModal.onDidDismiss(data => {
      console.log(data);
    });
    mapModal.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/register-recruiter/register-recruiter.ts